import { useQuery } from 'apollo-client'
import { usePathname } from 'router'

import pageSeosStrapiQuery from './graph/pageSeos.strapi.graphql'


const useGetSeoData = () => {
  const pathname = usePathname()

  const { data } = useQuery(pageSeosStrapiQuery, {
    client: 'strapi',
    fetchPolicy: 'cache-first',
    variables: {
      filters: {
        url: {
          eq: pathname,
        },
      },
    },
  })

  const { metaTitle, metaDescription } = data?.pageSeos?.data[0]?.attributes?.seo || {}

  return {
    metaTitle,
    metaDescription,
  }
}

export default useGetSeoData
